import { fillVariants } from "../../../styles/utils/fill"
import { classNames } from "../../../utils"
import type { IconProps } from "../../types"

export function Google({
  size = 24,
  fill = "current",
  fillAttribute = "currentColor",
  className,
  ...rest
}: IconProps) {
  return (
    <svg
      aria-label="Google"
      className={classNames(fillVariants({ fill }), className)}
      fill={fillAttribute}
      height={size}
      viewBox="0 0 20 20"
      width={size}
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <g clipPath="url(#clip0_2196_47208)">
        <path d="M0 10C0 4.486 4.486 0 10 0C12.227 0 14.3348 0.716476 16.0956 2.072L13.7718 5.09067C12.683 4.25257 11.3788 3.80952 10 3.80952C6.58657 3.80952 3.80952 6.58657 3.80952 10C3.80952 13.4134 6.58657 16.1905 10 16.1905C12.7492 16.1905 15.0855 14.3892 15.8907 11.9048H10V8.09524H20V10C20 15.514 15.514 20 10 20C4.486 20 0 15.514 0 10Z" />
      </g>
      <defs>
        <clipPath id="clip0_2196_47208">
          <rect height="20" width="20" />
        </clipPath>
      </defs>
    </svg>
  )
}
